module.exports = __webpack_public_path__ + "img/iconNext.2f2af9ed.svg";